export class OrganizationModel {
    constructor(
        public id: string,
        public code: string,
        public name: string,
        public contact: string,
        public salutation: string,
        public telephone: string,
        public address1: string,
        public address2: string,
        public address3: string,
        public address4: string,
        public fax: string,
        public memo: string,
        public email: string,
        public country: string,
        public discount: string,
        public createdDate: string,
        public active: any,
        public patientRegPassword: string,
        public patientRegCount: string,
        public patientRegContact: string,
        public patientRegExpires: string,
        public limitedAmount: string,
        public note: string,
    ) { }
}

export class ManageOrganizationModel {
    constructor(
        public id: string,
        public name: string,
        public address: string,
        public telephone: string,
        public email: string,
        public active: string
    ) {
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/organization/organization.model.ts